<ng-container *ngIf="!isValueCopied; else copiedTpl">
  <loop-icon (click)="copyValue()" name="copy" class="clickable-icon" width="16px" height="16px"></loop-icon>
</ng-container>

<ng-template #copiedTpl>
  <loop-icon name="check" class="confirmed" width="16px" height="16px"></loop-icon>
</ng-template>
